import { lazy } from '../../shared/deployment';

export const MediableTypeSwitch = lazy(() => import('./MediableTypeSwitch'));
export const MediaSelect = lazy(() => import('./MediaSelect'));
export const MediaSearchPanel = lazy(() => import('./MediaSearchPanel'));
export const MediaSearchFilters = lazy(() => import('./MediaSearchFilters'));
